import styled from "styled-components";

export const Main = styled.div`
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 486px;
    border-radius: 8px;
    background-color: #fff;
`;

export const Overlay = styled.div`
    background: linear-gradient(180deg, rgba(187, 189, 191, 0.2) 0%, rgba(187, 189, 191, 0.52) 23.96%, rgba(187, 189, 191, 0.52) 52.08%, rgba(187, 189, 191, 0.52) 86.46%);
    backdrop-filter: blur(3px);
`;

export const Btn = styled.button<{label?: string}>`
  padding: 8px 46px;
  cursor: pointer;
  user-select: none;
  background: #fff;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.26px;
`
